import { render, staticRenderFns } from "./MailSegnalazioneReply.vue?vue&type=template&id=4207f39a&scoped=true"
import script from "./MailSegnalazioneReply.vue?vue&type=script&lang=js"
export * from "./MailSegnalazioneReply.vue?vue&type=script&lang=js"
import style0 from "./MailSegnalazioneReply.vue?vue&type=style&index=0&id=4207f39a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4207f39a",
  null
  
)

export default component.exports